module.exports = {
"codeEval": function(callback){
                var response = require("responses/tags/codeEval/codeEval");
                callback(null, response);                
            },
"changePageContent": function(callback){
                var response = require("responses/tags/changePageContent/changePageContent");
                callback(null, response);                
            },
"saveErrors": function(callback){
                require.ensure(["responses/data-collection/saveErrors/saveErrors"], function(require){
                    var response = require("responses/data-collection/saveErrors/saveErrors");
                    callback(null, response);
                }, "responses/data-collection/saveErrors/saveErrors")                
            },
"saveContent": function(callback){
                require.ensure(["responses/data-collection/saveContent/saveContent"], function(require){
                    var response = require("responses/data-collection/saveContent/saveContent");
                    callback(null, response);
                }, "responses/data-collection/saveContent/saveContent")                
            },
"saveUrlParams": function(callback){
                require.ensure(["responses/data-collection/saveUrlParams/saveUrlParams"], function(require){
                    var response = require("responses/data-collection/saveUrlParams/saveUrlParams");
                    callback(null, response);
                }, "responses/data-collection/saveUrlParams/saveUrlParams")                
            },
"trackExitIntent": function(callback){
                require.ensure(["responses/data-collection/trackExitIntent/trackExitIntent"], function(require){
                    var response = require("responses/data-collection/trackExitIntent/trackExitIntent");
                    callback(null, response);
                }, "responses/data-collection/trackExitIntent/trackExitIntent")                
            },
"trackGTMEvents": function(callback){
                require.ensure(["responses/data-collection/trackGTMEvents/trackGTMEvents"], function(require){
                    var response = require("responses/data-collection/trackGTMEvents/trackGTMEvents");
                    callback(null, response);
                }, "responses/data-collection/trackGTMEvents/trackGTMEvents")                
            },
"saveContentScore": function(callback){
                require.ensure(["responses/data-collection/saveContentScore/saveContentScore"], function(require){
                    var response = require("responses/data-collection/saveContentScore/saveContentScore");
                    callback(null, response);
                }, "responses/data-collection/saveContentScore/saveContentScore")                
            },
"switchTrigger": function(callback){
                require.ensure(["responses/data-collection/switchTrigger/switchTrigger"], function(require){
                    var response = require("responses/data-collection/switchTrigger/switchTrigger");
                    callback(null, response);
                }, "responses/data-collection/switchTrigger/switchTrigger")                
            },
"readStats": function(callback){
                require.ensure(["responses/data-feeds/readDataFeed/readStats"], function(require){
                    var response = require("responses/data-feeds/readDataFeed/readStats");
                    callback(null, response);
                }, "responses/data-feeds/readDataFeed/readDataFeed")                
            },
"readPivot": function(callback){
                require.ensure(["responses/data-feeds/readDataFeed/readPivot"], function(require){
                    var response = require("responses/data-feeds/readDataFeed/readPivot");
                    callback(null, response);
                }, "responses/data-feeds/readDataFeed/readDataFeed")                
            },
"showMessage": function(callback){
                require.ensure(["responses/surveys/dialog/showMessage"], function(require){
                    var response = require("responses/surveys/dialog/showMessage");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"showChoiceMessage": function(callback){
                require.ensure(["responses/surveys/dialog/showChoiceMessage"], function(require){
                    var response = require("responses/surveys/dialog/showChoiceMessage");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"showQuestion": function(callback){
                require.ensure(["responses/surveys/dialog/showQuestion"], function(require){
                    var response = require("responses/surveys/dialog/showQuestion");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"showClosedQuestion": function(callback){
                require.ensure(["responses/surveys/dialog/showClosedQuestion"], function(require){
                    var response = require("responses/surveys/dialog/showClosedQuestion");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"showTagsQuestion": function(callback){
                require.ensure(["responses/surveys/dialog/showTagsQuestion"], function(require){
                    var response = require("responses/surveys/dialog/showTagsQuestion");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"askForEmail": function(callback){
                require.ensure(["responses/surveys/dialog/askForEmail"], function(require){
                    var response = require("responses/surveys/dialog/askForEmail");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"contactForm": function(callback){
                require.ensure(["responses/surveys/dialog/contactForm"], function(require){
                    var response = require("responses/surveys/dialog/contactForm");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"showLikertSurvey": function(callback){
                require.ensure(["responses/surveys/dialog/showLikertSurvey"], function(require){
                    var response = require("responses/surveys/dialog/showLikertSurvey");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"showMatrixQuestion": function(callback){
                require.ensure(["responses/surveys/dialog/showMatrixQuestion"], function(require){
                    var response = require("responses/surveys/dialog/showMatrixQuestion");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"showComboQuestion": function(callback){
                require.ensure(["responses/surveys/dialog/showComboQuestion"], function(require){
                    var response = require("responses/surveys/dialog/showComboQuestion");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"showOrderedTagsQuestion": function(callback){
                require.ensure(["responses/surveys/dialog/showOrderedTagsQuestion"], function(require){
                    var response = require("responses/surveys/dialog/showOrderedTagsQuestion");
                    callback(null, response);
                }, "responses/surveys/dialog/dialog")                
            },
"addToRemarketingList": function(callback){
                require.ensure(["responses/tags/addToRemarketingList/addToRemarketingList"], function(require){
                    var response = require("responses/tags/addToRemarketingList/addToRemarketingList");
                    callback(null, response);
                }, "responses/tags/addToRemarketingList/addToRemarketingList")                
            },
"underTheFoldIndicator": function(callback){
                require.ensure(["responses/uihints/underTheFoldIndicator/underTheFoldIndicator"], function(require){
                    var response = require("responses/uihints/underTheFoldIndicator/underTheFoldIndicator");
                    callback(null, response);
                }, "responses/uihints/underTheFoldIndicator/underTheFoldIndicator")                
            },
"addJavaScriptTags": function(callback){
                require.ensure(["responses/tags/addJavaScriptTags/addJavaScriptTags"], function(require){
                    var response = require("responses/tags/addJavaScriptTags/addJavaScriptTags");
                    callback(null, response);
                }, "responses/tags/addJavaScriptTags/addJavaScriptTags")                
            },
"splitTrafficIntoGroups": function(callback){
                require.ensure(["responses/data-collection/splitTrafficIntoGroups/splitTrafficIntoGroups"], function(require){
                    var response = require("responses/data-collection/splitTrafficIntoGroups/splitTrafficIntoGroups");
                    callback(null, response);
                }, "responses/data-collection/splitTrafficIntoGroups/splitTrafficIntoGroups")                
            },
"showHideContent": function(callback){
                require.ensure(["responses/tags/showHideContent/showHideContent"], function(require){
                    var response = require("responses/tags/showHideContent/showHideContent");
                    callback(null, response);
                }, "responses/tags/showHideContent/showHideContent")                
            },
"navigateToURL": function(callback){
                require.ensure(["responses/navigate/navigateToURL/navigateToURL"], function(require){
                    var response = require("responses/navigate/navigateToURL/navigateToURL");
                    callback(null, response);
                }, "responses/navigate/navigateToURL/navigateToURL")                
            },
"notify": function(callback){
                require.ensure(["responses/notifications/notify/notify"], function(require){
                    var response = require("responses/notifications/notify/notify");
                    callback(null, response);
                }, "responses/notifications/notify/notify")                
            },
"onscreenNotification": function(callback){
                require.ensure(["responses/notifications/onscreen/onscreenNotification"], function(require){
                    var response = require("responses/notifications/onscreen/onscreenNotification");
                    callback(null, response);
                }, "responses/notifications/onscreen/onscreen")                
            },
"statusBar": function(callback){
                require.ensure(["responses/notifications/onscreen/statusBar"], function(require){
                    var response = require("responses/notifications/onscreen/statusBar");
                    callback(null, response);
                }, "responses/notifications/onscreen/onscreen")                
            },
"deadlineTimer": function(callback){
                require.ensure(["responses/notifications/onscreen/deadlineTimer"], function(require){
                    var response = require("responses/notifications/onscreen/deadlineTimer");
                    callback(null, response);
                }, "responses/notifications/onscreen/onscreen")                
            },
"changeTitle": function(callback){
                require.ensure(["responses/notifications/browser/changeTitle"], function(require){
                    var response = require("responses/notifications/browser/changeTitle");
                    callback(null, response);
                }, "responses/notifications/browser/browser")                
            },
"showVisual": function(callback){
                require.ensure(["responses/notifications/onscreen/showVisual"], function(require){
                    var response = require("responses/notifications/onscreen/showVisual");
                    callback(null, response);
                }, "responses/notifications/onscreen/onscreen")                
            }};


//////////////////
// WEBPACK FOOTER
// ./responsesLoader.js!./responses.json
// module id = 2
// module chunks = 0